export default "__VITE_ASSET__BFdg59xZ__"